import { UserStatus } from 'api/types/user'

export const userStatusOptions = [
  { value: UserStatus.Active, label: 'Active' },
  { value: UserStatus.Inactive, label: 'Inactive' },
  { value: UserStatus.Invited, label: 'Invited' },
]
